import React from 'react'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'

export const FORCE_SAVE_RR_MODAL = 'FORCE_SAVE_RR_MODAL'

export class ForceSaveRRModal extends React.PureComponent {
  onLoadLatestClicked = () => {
    const { loadLatest, reinitialize, onRequestClose } = this.props
    loadLatest()
      .then(r => reinitialize())
      .then(r => onRequestClose())
  }

  onOverwriteClicked = () => {
    const { overwrite, onRequestClose } = this.props
    overwrite().then(r => onRequestClose())
  }

  render () {
    return (
      <ModalOverlay
        showCloseButton={false}
        maxWidth='400px'
        title='Newer version detected'>
        <p>You have saved a newer version of this ride report</p>
        <CTA onClick={this.onLoadLatestClicked}>Load latest version</CTA>
        <CTA onClick={this.onOverwriteClicked}>Overwrite with current version</CTA>
      </ModalOverlay>
    )
  }
}
